module.exports = __webpack_public_path__ + "static/media/tokenomics-pie-chart-small.29672004.png";